module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACAQMAAABbr9+TAAAAA1BMVEXlTk73zSGNAAAAC0lEQVQI12NgAAEAAAYAAWb0yWwAAAAASUVORK5CYII="